export const siteName = "National Lottery Casino";
